import React from 'react'
import Container from '../components/Container'
import web3 from "../assets/svgs/decentralized.svg"
import tutorial from "../assets/svgs/tutorial.svg"
import test from "../assets/svgs/test.svg"
import cv from "../assets/svgs/cv.svg"
import interview from "../assets/svgs/interview.svg"
import huggingFace from "../assets/svgs/hugging-face.svg"
import Button from '../components/Button'
import Badges from '../components/dashboard/Badges'
import Activities from '../components/dashboard/Activities'
import { Link, useNavigate } from 'react-router-dom'

const Dashboard = () => {
    const navigate = useNavigate()
  return (
    <Container>
        <div className='grid grid-cols-[70%_30%] h-[inherit] w-[inherit] font-poppins'>
            <div>
                <div className='w-[100%] bg-main-blue h-[22%]  mt-2 rounded-2xl grid grid-cols-[80%_20%]'>
                    <div className='flex flex-col justify-center pl-10 text-white'>
                        <p className='mb-3 flex '>
                            Hello Chinonye 
                            <img src = {huggingFace} alt='' />
                        </p>
                        <p className='font-light tracking-wide'>Good to see you! Let's crush those job goals.</p>
                    </div>
                    <div>
                        <img src= {web3} alt=''/>
                    </div>
                </div>
                <div className='grid grid-cols-2 w-[100%] gap-8 mt-5 text-main-black'>
                    <Link to="/tutorials">   
                    <div className='bg-[rgba(255,_255,_255,_0.5)] [box-shadow:_0px_2px_25px_1px_rgba(1,_126,_145,_0.05)] grid grid-cols-2  rounded-2xl p-2'>
                        <div>
                            <img src = {tutorial}  alt = "tutorial" />
                        </div>
                        <div className='flex items-center'>
                            Tutorial
                        </div>
                    </div>
                    </Link>
                    <div className='bg-[rgba(255,_255,_255,_0.5)] [box-shadow:_0px_2px_25px_1px_rgba(1,_126,_145,_0.05)] grid grid-cols-[40%_60%]  rounded-2xl p-2'>
                        <div>
                            <img src = {test}  alt = "tutorial" />
                        </div>
                        <div className='flex items-center'>
                            Tests and assessments
                        </div>
                    </div>
                    <Link to = "/cvreview">
                    <div className='bg-[rgba(255,_255,_255,_0.5)] [box-shadow:_0px_2px_25px_1px_rgba(1,_126,_145,_0.05)] grid grid-cols-2  rounded-2xl p-2'>
                        <div>
                            <img src = {cv}  alt = "tutorial" />
                        </div>
                        <div className='flex items-center'>
                        CV review
                        </div>
                    </div>
                    </Link>
                    <Link to = "/interview">
                    <div className='bg-[rgba(255,_255,_255,_0.5)] [box-shadow:_0px_2px_25px_1px_rgba(1,_126,_145,_0.05)] grid grid-cols-[40%_60%]  rounded-2xl p-2'>
                        <div>
                            <img src = {interview}  alt = "tutorial" />
                        </div>
                        <div className='flex items-center'>
                            Interview practice
                        </div>
                    </div>
                    </Link>
                </div>
                <div className='flex flex-col justify-center items-center mt-4'>
                    <Button onClick = {() => navigate('/registerTutor')}>
                        Become a Tutor
                    </Button>
                    <p className='font-light text-sm mt-3'>Become a tutor today and have your contents </p>
                    <p className='font-light text-sm'>visible to thousands of people</p>
                </div>
            </div>
            <div className = "grid grid-rows-[37%_63%] gap-5">
                <Badges />
                <Activities />
            </div>
        </div>
    </Container>
  )
}

export default Dashboard